import React from 'react';
import ReactDOM from 'react-dom/client';
import { Analytics } from '@vercel/analytics/react';
import App from './App';
import './index.css';

// Enable debug logging
console.log('Initializing React application...');

// Check if root element exists
const rootElement = document.getElementById('root');
if (!rootElement) {
    console.error('Failed to find root element with id "root"');
    throw new Error('Root element not found');
}

console.log('Root element found, creating React root...');

ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
        <App />
        <Analytics />
    </React.StrictMode>
);

console.log('React application mounted successfully'); 